/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://master.api.pir.ru/api/v3';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
